import axiosInstance from "../utils/axiosInstance";
import { CookieUtils } from "../utils";

class OrderService {
  async orderVerify(params) {
    const req = {
      operationName: null,
      query: `query MtiVerifyOrder($objRequest: String) {
        mtiVerifyOrder(objRequest: $objRequest) {
          success
          message
          payload {
            info
            hash
          }
        }
      }`,
      variables: {
        objRequest: JSON.stringify(params),
      },
    };
    
    const accessToken = CookieUtils.getCookie("gtt_access_token");
    
    return axiosInstance
      .post("", req, { 
        headers: { 
          authorization: accessToken,
        } 
      })
      .then((res) => {
        return {
          info: JSON.parse(res.data.data.mtiVerifyOrder.payload.info),
          hash: JSON.parse(res.data.data.mtiVerifyOrder.payload.hash),
        };
      });
  }
  async saveReceipt() {
    const req = {
      operationName: null,
      query: `query MtiInsertReceipt($refId: String, $receipt: String) {
        mtiInsertReceipt(ref_id: $refId, receipt: $receipt) {
          success
          message
          code
        }
      }`,
      variables: {
        refId: req.ref_id,
        receipt: req.receipt,
      },
    };
    
    const accessToken = CookieUtils.getCookie("gtt_access_token");
    
    return axiosInstance
      .post("", req, { 
        headers: { 
          authorization: accessToken,
        } 
      })
      .then((res) => res.data || {});
  }
}

export default new OrderService();
